// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"414":"7850326c","453":"5b5f864b"}[chunkId] + ".chunk.js";
};